<div class="volume-wrapper">
  <span class="volume-text ods-typography-body-s-regular">{{ 'products_volume' | translate }}</span>
  <div class="volume-bar-container">
    <div #volumeBar class="volume-bar" [class]="volumeBarClass"></div>
  </div>
</div>
